// extracted by mini-css-extract-plugin
export default {"closeButton":"N+eei","page":"LKVt7","title":"gpdi2","description":"AGV1w","loginButtonContainer":"HXbdj"};